import React from 'react';
import propTypes from 'prop-types';

const MapControls = ({
  children
}) => {
  return (
    <div className='vra-map-controls'>
      {children}
    </div>
  );
};

MapControls.propTypes = {
  children: propTypes.node
};

export default MapControls;
